import styled from 'styled-components'

export const Content = styled.h4`
  font-family: ${({ font }) => font};
  color: ${({ color }) => color};
  font-size: 16px;
  line-height: 21px;
  min-height: 21px;
  margin: 0;
`
